"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNewScript = exports.createNewDeferScript = exports.createNewAsyncScript = exports.addScriptFirstToDocument = exports.addScriptToDocument = void 0;
const addScriptToDocument = (script) => {
    document.head.appendChild(script);
};
exports.addScriptToDocument = addScriptToDocument;
const addScriptFirstToDocument = (script) => {
    var _a;
    const firstScriptInDocument = document.getElementsByTagName('script')[0];
    (_a = firstScriptInDocument === null || firstScriptInDocument === void 0 ? void 0 : firstScriptInDocument.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(script, firstScriptInDocument);
};
exports.addScriptFirstToDocument = addScriptFirstToDocument;
const createNewAsyncScript = () => {
    const script = document.createElement('script');
    script.async = true;
    return script;
};
exports.createNewAsyncScript = createNewAsyncScript;
const createNewDeferScript = () => {
    const script = document.createElement('script');
    script.defer = true;
    return script;
};
exports.createNewDeferScript = createNewDeferScript;
const createNewScript = () => {
    const script = document.createElement('script');
    return script;
};
exports.createNewScript = createNewScript;
//# sourceMappingURL=helper.js.map